export default {
  id: "e590843c-18a2-4fc2-ae94-fd658051f93b",
  icon: "mdi-book-multiple",
  name: "libraryContentCustom",
  title: "Library Content Custom",
  description: "Customizable block for Library content.",
};
